export default function Taiwan() {
  return (
    <div className="flex justify-center px-4">
      <article className="prose prose-invert max-w-2xl pt-12 prose-p:my-2 prose-li:my-1 prose-h2:mb-3">

        <h1>Taiwan's FX Time Bomb</h1>
        <p>The <strong>Taiwanese dollar</strong> has ripped over <strong>10%</strong> since April. Last week’s spike wasn’t noise it’s the beginning of a structural unwind.</p>

        <h2>Here’s the setup:</h2>
        <p>Taiwan holds $1.7T in FX reserves around 200% of GDP. Insurers hold $700B heavily regulated. Another $1T is privately held. Most importantly there are $450B in USD assets against TWD liabilities about <strong>60% of GDP unhedged</strong>.</p>

        <p>Taiwan’s life insurers are inherently <strong>long the dollar</strong>. But with <strong>DXY down 9% YTD</strong> the pain trade is on. Rebalancing has begun.</p>

        <h2>Global Flow Reversal Is Real</h2>
        <p>It’s not just TWD. The euro is also up 10% YTD. SGD is rallying too. This is a coordinated flow reversal. Foreign capital is moving home. Hot money is pulling out of the US.</p>

        <p>From 2012 to 2022 US equities floated between 52–57% of global market cap. Now? <strong>66%</strong>.</p>

        <img src="/my-dark-blog-main/USEQUITYCAP.png" alt="Global equity chart" className="rounded-xl shadow-md my-8" />

        <p>This can resolve three ways the US stays flat the rest of the world catches up or we see a direct correction in the US.</p>

        <h2>The Trade: Rotate Out of the US</h2>
        <p>Look at Brazil’s EWZ 9x P/E and an 8% yield with a China tailwind. In Germany RWE ADR trades at just 15x P/E far cheaper than US utilities. Broader DAX and MDAX exposure gives you Siemens BASF and Rheinmetall. In defense Europe’s BAE and Dassault are strong plays.</p>

        <p>On the short side Mag 7 and the Nasdaq-100 are crowded and long duration. US utilities are trading at 20–25x P/E and have no macro catalyst behind them.</p>

        <p>Long EM and Europe. Short US megacaps. FX pain capital flight and global stimulus point to a regime shift.</p>

        <p><strong>If it works?</strong> You’re early.</p>
        <p><strong>If it doesn’t?</strong> You’re not dead.</p>
        <p>This is <strong>how it starts</strong> not with a bang but with a <strong>currency squeeze</strong>.</p>

      </article>
    </div>
  );
}
